import "core-js/stable";
import "regenerator-runtime/runtime";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider, StyleSheetManager } from "styled-components";
import React from "react";
import Globalize from "../../../common-deprecated/Globalize";
import * as History from "../../../common-deprecated/History";
import { historyEvent } from "../../../common-deprecated/redux/actions/UtilActions";
import InitializeCod from "./utils/InitializeCod";
import InitializeSalesman from "../../../common-deprecated/InitializeSalesman";
import { getThemeClassname, removeLastSlashAndWhiteSpace } from "../../../common-deprecated/utils";
import { type BuildAndBuyStateType, buildAndBuyClientStore } from "./redux/store";
import { getPostal } from "../../../common-deprecated/utils/postalUtils";
import getTheme from "../../../common-deprecated/themes/getTheme";
import { renderReact } from "../../../common-deprecated/utils/clientRenderUtils";
import { ModalProvider } from "../../../common-deprecated/containers/ModalProvider";
import { getModelIdSelector } from "./utils/typedUtils";
import { WindowDimensionsProvider } from "../../../common-deprecated/containers/WindowDimensionsProvider";
import { POSTAL_CHANNEL_T1_CARCONFIG, POSTAL_TOPIC_CARCONFIG_INIT } from "../../../common-deprecated/constants";
import { shouldForwardProp } from "../../../shared-logic/utils/styledComponentsUtils";

export const getInit =
    (BuildAndBuyComponent: React.ElementType) =>
    (target: string, props: { autoInitialize?: boolean }, initialState: BuildAndBuyStateType): void => {
        const { commonSettings } = initialState;
        const { country, culture, currencyMultiplier } = commonSettings;
        const { autoInitialize } = props;

        // eslint-disable-next-line camelcase
        __webpack_public_path__ = `${removeLastSlashAndWhiteSpace(commonSettings.resourcePath)}/`;

        const modelId = getModelIdSelector(initialState);
        const themeClassName = getThemeClassname(modelId);

        // Initialize store, tagging and globalize.
        const store = buildAndBuyClientStore(initialState, commonSettings.component);

        History.listen((location, action) => {
            store.dispatch(historyEvent(location, action));
        });

        InitializeCod(commonSettings, store);
        InitializeSalesman(commonSettings, store);

        const initialize = (): void => {
            Globalize(country, culture, currencyMultiplier);
            renderReact(
                target,
                commonSettings,
                // Since react-redux 8, new development checks were introduced against incorrect usage of useSelector, mostly to detect unnecessary rerenders.
                // Make sure to not add the 'stabilityCheck="never"' in new components
                <ReduxProvider store={store} stabilityCheck="never">
                    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                        <ThemeProvider theme={getTheme(commonSettings)}>
                            <WindowDimensionsProvider>
                                <ModalProvider className={themeClassName}>
                                    <BuildAndBuyComponent />
                                </ModalProvider>
                            </WindowDimensionsProvider>
                        </ThemeProvider>
                    </StyleSheetManager>
                </ReduxProvider>,
            );
        };

        // autoInitialize is an optional request body parameter, hence we need to explicitely check if it is false
        if (autoInitialize === false) {
            const postal = getPostal();
            postal.subscribe({
                channel: POSTAL_CHANNEL_T1_CARCONFIG,
                topic: POSTAL_TOPIC_CARCONFIG_INIT,
                callback: initialize,
            });
        } else {
            initialize();
        }
    };
